//#region IMPORT
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
/** Services Import */
import { useDispatch, useSelector } from 'react-redux';
import { showSnackbar } from '../../../../Reducer/SnackbarReducer';
import { setDepCd } from '../../../../Reducer/SearchReducer';
import useCompanyCustDep from '../../../../hooks/useCompanyCustDep';
/** Components */
import { SAF_BASIC } from './index';
//#endregion

function SAF_BASICF() {
  //#region 변수
  const navigate = useNavigate();
  const routerLocation = useLocation();
  const dispatch = useDispatch();
  const { userInfo, custInfo, lanInfo } = useSelector(
    (state) => state.BaseInfo
  );
  const searchInfo = useSelector((state) => state.SearchInfo);

  const [value, setValue] = React.useState(0);
  const [custCd, setCustCd] = useState('');

  // 회사/거래처 선택 상태 관리 및 필수 여부 검증을 위한 Hook
  const {
    handleCoChange,
    handleCustChange,
    handleDepChange,
    validateSelection,
  } = useCompanyCustDep({
    requireCompany: true,
    requireCust: true,
    requireDep: true,
  });

  const [filterClick1, setFilterClick1] = useState(false); // 1번탭 버튼 이벤트
  const [searchClick1, setSearchClick1] = useState(false);
  const [addClick1, setAddClick1] = useState(false);
  const [saveClick1, setSaveClick1] = useState(false);
  const [deleteClick1, setDeleteClick1] = useState(false);
  const [printClick1, setPrintClick1] = useState(false);
  const [copyClick1, setCopyClick1] = useState(false);
  const [listClick1, setListClick1] = useState(false);

  const [filterClick2, setFilterClick2] = useState(false); // 2번탭 버튼 이벤트
  const [searchClick2, setSearchClick2] = useState(false);
  const [addClick2, setAddClick2] = useState(false);
  const [saveClick2, setSaveClick2] = useState(false);
  const [deleteClick2, setDeleteClick2] = useState(false);
  const [printClick2, setPrintClick2] = useState(false);
  const [copyClick2, setCopyClick2] = useState(false);
  const [listClick2, setListClick2] = useState(false);
  //#endregion

  const executed = useRef(false);

  /** 홈 확인사항 등에서 `?openPermit=1`로 진입 시 안전작업 허가서 탭(1) 오픈 */
  useEffect(() => {
    if (!searchInfo.custCd) return;

    const params = new URLSearchParams(routerLocation.search);
    const openPermit = params.get('openPermit') === '1';

    const StripOpenPermitFromUrl = () => {
      if (!params.has('openPermit')) return;
      params.delete('openPermit');
      const qs = params.toString();
      navigate(
        {
          pathname: routerLocation.pathname,
          search: qs ? `?${qs}` : '',
        },
        { replace: true }
      );
    };

    if (!executed.current) {
      executed.current = true;
      if (openPermit) {
        setValue(1);
        setSearchClick2(true);
        StripOpenPermitFromUrl();
      } else {
        setSearchClick1(true);
      }
      return;
    }

    if (openPermit) {
      setValue(1);
      dispatch(setDepCd(''));
      setSearchClick2(true);
      StripOpenPermitFromUrl();
    }
  }, [
    searchInfo.custCd,
    routerLocation.search,
    routerLocation.pathname,
    navigate,
    dispatch,
  ]);

  // 탭 클릭 이벤트
  const HandleChange = (event, newValue) => {
    if (newValue === 0) setSearchClick1(true);
    else if (newValue === 1) setSearchClick2(true);

    setValue(newValue);
  };

  //#endregion

  return (
    <div className="wrap">
      <SAF_BASIC
        navigate={navigate}
        userInfo={userInfo}
        lanInfo={lanInfo}
        searchInfo={searchInfo}
        value={value}
        filterClick1={filterClick1}
        setFilterClick1={setFilterClick1}
        searchClick1={searchClick1}
        setSearchClick1={setSearchClick1}
        addClick1={addClick1}
        setAddClick1={setAddClick1}
        saveClick1={saveClick1}
        setSaveClick1={setSaveClick1}
        deleteClick1={deleteClick1}
        setDeleteClick1={setDeleteClick1}
        printClick1={printClick1}
        setPrintClick1={setPrintClick1}
        copyClick1={copyClick1}
        setCopyClick1={setCopyClick1}
        listClick1={listClick1}
        setListClick1={setListClick1}
        filterClick2={filterClick2}
        setFilterClick2={setFilterClick2}
        searchClick2={searchClick2}
        setSearchClick2={setSearchClick2}
        addClick2={addClick2}
        setAddClick2={setAddClick2}
        saveClick2={saveClick2}
        setSaveClick2={setSaveClick2}
        deleteClick2={deleteClick2}
        setDeleteClick2={setDeleteClick2}
        printClick2={printClick2}
        setPrintClick2={setPrintClick2}
        copyClick2={copyClick2}
        setCopyClick2={setCopyClick2}
        listClick2={listClick2}
        setListClick2={setListClick2}
        custCd={custCd}
        setCustCd={setCustCd}
        // getDepLastName={getDepLastName}
        dispatch={dispatch}
        showSnackbar={showSnackbar}
        // 회사, 사업장 관련 props
        handleCoChange={handleCoChange}
        handleCustChange={handleCustChange}
        handleDepChange={handleDepChange}
        validateSelection={validateSelection}
        // 함수
        HandleChange={HandleChange}
      />
    </div>
  );
}

export default SAF_BASICF;
